var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.1515H9.5V19.8947H14.5V17.1515ZM6.99708 22H17.0029C17.5843 22 18.0556 21.5287 18.0556 20.9474C18.0556 20.366 17.5843 19.8947 17.0029 19.8947H6.99708C6.41572 19.8947 5.94444 20.366 5.94444 20.9474C5.94444 21.5287 6.41572 22 6.99708 22ZM19.5 17.1515H4.5C3.39543 17.1515 2.5 16.2561 2.5 15.1515V4C2.5 2.89543 3.39543 2 4.5 2H19.5C20.6046 2 21.5 2.89543 21.5 4V15.1515C21.5 16.2561 20.6046 17.1515 19.5 17.1515Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.4ab7439381edf07d8a3e431ebaebebc7.svg";
export { ForwardRef as ReactComponent };